<template>
  <component :is="type" :item="item" :class="componentClass" />
</template>

<script>
import { mapState } from 'vuex'
import RepeaterMatrixTypeSection from '@/components/repeater-matrix-type-section'
import RepeaterMatrixTypeSingle from '@/components/repeater-matrix-type-single'
import RepeaterMatrixTypeDouble from '@/components/repeater-matrix-type-double'
import RepeaterMatrixTypeTable from '@/components/repeater-matrix-type-table'
import RepeaterMatrixTypeImages from '@/components/repeater-matrix-type-images'

export default {
  components: {
    RepeaterMatrixTypeSection,
    RepeaterMatrixTypeSingle,
    RepeaterMatrixTypeDouble,
    RepeaterMatrixTypeTable,
    RepeaterMatrixTypeImages
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState(['currentSection']),
    componentClass() {
      return [
        this.$style.component,
        this.item.section === this.currentSection
          ? this.$style['is-active']
          : ''
      ]
    },
    type() {
      const type = this.item.type.replace(/\s+|_+/g, '-').toLowerCase()
      return `repeater-matrix-${type}`
    }
  }
}
</script>

<style lang="scss" module>
.component {
  transition: color var(--short) ease;

  &.is-active {
    color: var(--white);
  }
}
</style>
